import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

// Contract: TASK-10 §8 — GET /api/v1/plannings/{id}/continuity/
// Returns: [{ topic, enrolled, already_taken, never_taken, taken_by[], suggestion }]
function useContinuity(planningId) {
  return useQuery({
    queryKey: ["plannings", planningId, "continuity"],
    queryFn: () =>
      apiClient
        .get(`/api/v1/plannings/${planningId}/continuity/`)
        .then((r) => r.data),
    enabled: !!planningId,
  });
}

export { useContinuity };
